import React from 'react'
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CautionImg from '../assets/caution_img.svg'

const ExitInfo = () => {
    const theme = useTheme();
    return <>
        <Box sx={{ marginTop: "24px", marginBottom: "15px", display: "flex", justifyContent: "flex-start", alignItems: "center", backgroundColor: "#FFFEE7", width: "100%", padding: "8px 8px", borderRadius: "4px" }}>
            <img src={CautionImg} alt='Caution' width={20} height={20} />
            <Box sx={{ color: theme.palette.darkBrown.main, fontSize: "14px", fontWeight: theme.typography.fontWeightSemibold, marginLeft: "10px" }}>Valet Payment will be taken at the exit. Please pay the operator at the exit gate.</Box>
        </Box>
    </>
}

export default ExitInfo